import { render, staticRenderFns } from "./oa.vue?vue&type=template&id=1a4093e2&scoped=true"
import script from "./oa.vue?vue&type=script&lang=js"
export * from "./oa.vue?vue&type=script&lang=js"
import style0 from "./oa.vue?vue&type=style&index=0&id=1a4093e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4093e2",
  null
  
)

export default component.exports